import { createSlice } from '@reduxjs/toolkit';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const celebritiesApi = createApi({
  reducerPath: 'celebritiesApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/api' }),
  tagTypes: ['Celebrity'],
  endpoints: builder => ({
    fetchCelebrities: builder.query<any[], void>({
      query: () => ({
        url: '/users/mypick',
        method: 'GET',
      }),
      keepUnusedDataFor: 24 * 60 * 60,
    }),
  }),
});

export const { useLazyFetchCelebritiesQuery } = celebritiesApi;

interface celebrityState {
  celebrities: { id: string; english: string; korean: string; image: string }[];
  celebritiesKoreanName: string[];
}

const initialCelebrityState: celebrityState = {
  celebrities: [],
  celebritiesKoreanName: [],
};

const celebritiesSlice = createSlice({
  name: 'celebrities',
  initialState: initialCelebrityState,
  reducers: {
    setCelebrities(state, action) {
      state.celebrities = action.payload;
      state.celebritiesKoreanName = action.payload.map(
        (celeb: { korean: string }) => celeb.korean,
      );
    },
  },
});

export const { setCelebrities } = celebritiesSlice.actions;

export default celebritiesSlice.reducer;
